export { WaitingListModal } from './WaitingListModal'


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/WaitingListModal/index.js